module.exports = __webpack_public_path__ + "img/s8-img1.77ccd2e2.png";